import { render, staticRenderFns } from "./total-info.vue?vue&type=template&id=355c70e2&scoped=true"
import script from "./total-info.vue?vue&type=script&lang=js"
export * from "./total-info.vue?vue&type=script&lang=js"
import style0 from "./total-info.vue?vue&type=style&index=0&id=355c70e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c70e2",
  null
  
)

export default component.exports